import { useEffect, useRef, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { ProgressSpinner } from 'primereact/progressspinner';
import '../styles.css';
import { GetCareers } from '../../../../services';
import { Career, CareerPrice, CareerSupplier, RegisterLinkType } from '../../../../interfaces';
import axios, { AxiosError } from 'axios';
import { SubmitHandler, useForm } from 'react-hook-form';

type DialogCreateLinkTypes = {
  open: boolean;
  close: () => void;
  actionToast: (action: string) => void;
  addData: (data: any) => void;
};

export const DialogCreateLink = (props: DialogCreateLinkTypes) => {
  const modalRef = useRef<HTMLDivElement>(null!);
  const containerRef = useRef<HTMLDivElement>(null!);
  const [inputEmail, setInputEmail] = useState('');
  const [selectedCareers, setSelectedCareers] = useState<Career>(null!);
  const [selectForm, setSelectForm] = useState<any>(null!);
  const [nameUser, setNameUser] = useState<string | number>(null!);
  const { careers } = GetCareers();
  const [disabledInput, setdisabledInput] = useState(true);
  const [errorEmail, setErrorEmail] = useState(false);
  const [errorUserData, setErrorUserData] = useState(false);
  const { handleSubmit, setValue } = useForm<RegisterLinkType>();
  const [loading, setLoading] = useState(false);
  const [disabledForm, setDisabledForm] = useState(true);
  const [checkRadioBtn, setCheckRadioBtn] = useState(false);
  const [generations, setGenerations] = useState<any>(null!);
  const [discounts, setDiscounts] = useState<any>(null!);
  const [selectedGeneration, setSelectedGeneration] = useState<any>(null!);
  const [selectedDiscount, setSelectedDiscount] = useState<any>(null);
  const [selectedAllianceDiscount, setSelectedAllianceDiscount] = useState<any>(null);
  const [tuitionExempted, setTuitionExempted] = useState<any>(false);
  const [isVariant, setIsVariant] = useState<any>(false);
  const [selectedEnrollmentType, setSelectedEnrollmentType] = useState<any>(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState<any>(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>(null);
  const [quotes, setQuotes] = useState<number>(12);
  const [selectedSupplier, setSelectedSupplier] = useState<any>(null);
  const [selectedPrice, setSelectedPrice] = useState<CareerPrice | null>(null);
  const [selectedCurrency, setSelectedCurrency] = useState<{ id: number; code: string } | null>(null);
  const [availableSuppliers, setAvailableSuppliers] = useState<{ id: number; description: string; countries: string[] | null }[]>([]);

  const paymentTypes = [
    { id: 1, description: 'Boleta' },
    { id: 2, description: 'Factura' }
  ];

  const enrollmentTypes = [
    { id: 1, description: 'Base' },
    { id: 0, description: 'Pro' },
  ];


  const forms = [
    { name: 'Formulario de cursos', id: 2 },
    { name: 'Formulario de carrera simplificado', id: 5 }
  ];

  useEffect(() => {
    if (props.open) modalRef.current.style.display = 'flex';
  }, [props.open]);


  const closeModal = (): void => {
    setLoading(false);
    setDisabledForm(true);
    containerRef.current.classList.add('close');
    setTimeout(() => {
      containerRef.current.classList.remove('close');
      modalRef.current.style.display = 'none';
      props.close();
    }, 1000);
  };

  window.addEventListener(
    'click',
    (e: any) => e.target === modalRef.current && closeModal()
  );

  const searchUserByEmail = async () => {
    const email = inputEmail;
    setValue('email', email);

    await axios
      .get(
        `${process.env.REACT_APP_API_BACKEND}/hubspot/client/${inputEmail}/email`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token_hhrr_latam')}`
          }
        }
      )
      .then((response: any) => {
        const firstname = response.data.results[0].properties.firstname;
        const lastname = response.data.results[0].properties.lastname;

        if (!firstname || !lastname || firstname === null || lastname === null) {
          setErrorUserData(true);
          setErrorEmail(false);
          setdisabledInput(true);
          return;
        }

        setNameUser(`${firstname} ${lastname}`);
        setValue('name', firstname);
        setValue('lastname', lastname);
        setValue('lastname2', '');
        setdisabledInput(false);
        setErrorEmail(false);
        setErrorUserData(false);
      })
      .catch((error: AxiosError) => {
        console.log('Error ingress Email =>', error);
        setErrorEmail(true);
        setErrorUserData(false);
      });
  };

  const handleChangeCareer = async (value: Career) => {
    setSelectedCareers(value);
    setValue('career_id', value.id);
    setSelectedPrice(null);
    setCheckRadioBtn(false);
    setSelectedCurrency(null);
    setAvailableSuppliers([]);
    setSelectedPaymentMethod(null);
    setValue('payment_method_id', null);
    setSelectedSupplier(null);
    setValue('supplier', null);
    getGenerations(value.id);
    getDiscounts();
  };

  const fetchSuppliersByCountry = async (currencyCode: string) => {
    const country = CURRENCY_COUNTRY[currencyCode];
    const url = country
      ? `${process.env.REACT_APP_API_BACKEND}/suppliers?country=${country}`
      : `${process.env.REACT_APP_API_BACKEND}/suppliers`;
    try {
      const response = await axios.get(url, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token_hhrr_latam')}`
        }
      });
      setAvailableSuppliers(response.data);
    } catch (error) {
      console.log('Error fetching suppliers:', error);
      setAvailableSuppliers([]);
    }
  };

  const handleChangeCurrency = (value: { id: number; code: string } | null) => {
    setSelectedCurrency(value);
    setSelectedPrice(null);
    setValue('price_id', null);
    setCheckRadioBtn(false);
    setSelectedPaymentMethod(null);
    setValue('payment_method_id', null);
    setSelectedSupplier(null);
    setValue('supplier', null);
    if (value) {
      fetchSuppliersByCountry(value.code);
    } else {
      setAvailableSuppliers([]);
    }
  };

  const handleChangeGeneration = (value: any) => {
    setSelectedGeneration(value);
    setValue('generation_id', value.id);
    if (value.default_price_table_id && selectedCareers) {
      const defaultPrice = selectedCareers.prices.find(p => p.id === value.default_price_table_id);
      if (defaultPrice) {
        setSelectedPrice(defaultPrice);
        setValue('price_id', defaultPrice.id);
        setCheckRadioBtn(true);
        return;
      }
    }
    setSelectedPrice(null);
    setCheckRadioBtn(false);
  };

  const handleChangeDiscount = (value: any) => {
    setSelectedDiscount(value);
    setValue('discount_id', value ? value.id : null);
  };

  const handleChangeAllianceDiscount = (value: any) => {
    setSelectedAllianceDiscount(value);
    setValue('alliance_discount_id', value ? value.id : null);
  };

  const handleChangePaymentType = (value: any) => {
    setSelectedPaymentType(value);
    setValue('document_type_id', value.id);
  };

  const handleChangeEnrollmentType = (value: any) => {
    setSelectedEnrollmentType(value);
    setValue('enrollment_type', value ? value.id : null);
  };

  const handleChangePaymentMethod = (value: any) => {
    setSelectedPaymentMethod(value);
    setValue('payment_method_id', value ? value.id : null);
    setSelectedDiscount(null);
    setValue('discount_id', null);
    setSelectedAllianceDiscount(null);
    setValue('alliance_discount_id', null);
    if (value?.id === 1) {
      const pivotQuotes = value.pivot?.quotes ?? 12;
      setQuotes(pivotQuotes);
      setValue('quotes', pivotQuotes);
    } else {
      setValue('quotes', null);
    }
  };

  const paymentTypeMapping: Record<string, string> = {
    'Anticipado': 'Pago anticipado',
    'Pago Cuota': 'Cuotas',
  };

  const discountsByPaymentType = selectedPaymentMethod
    ? (discounts ?? []).filter((d: any) => d.payment_type === paymentTypeMapping[selectedPaymentMethod.description])
    : [];

  const campaignDiscounts = discountsByPaymentType.filter((d: any) => d.discount_type === 'Campaña');
  const allianceDiscounts = discountsByPaymentType.filter((d: any) => d.discount_type === 'Alianza');

  const totalDiscountPct = (selectedDiscount?.percentage ?? 0) + (selectedAllianceDiscount?.percentage ?? 0);

  const currencyLabels: Record<string, string> = {
    CLP: 'Chile (CLP)',
    PEN: 'Perú (PEN)',
    COP: 'Colombia (COP)',
    USD: 'Internacional (USD)',
    MXN: 'México (MXN)',
    ARS: 'Argentina (ARS)',
    BRL: 'Brasil (BRL)',
    UYU: 'Uruguay (UYU)',
    BOB: 'Bolivia (BOB)',
  };

  const availableCurrencies = selectedCareers
    ? Array.from(
        new Map(
          selectedCareers.prices
            .filter(p => p.currency != null)
            .map(p => [p.currency!.id, p.currency!])
        ).values()
      )
    : [];

  const CURRENCY_COUNTRY: Record<string, string> = {
    CLP: 'chile',
    PEN: 'peru',
    COP: 'colombia',
    MXN: 'mexico',
    USD: 'usa',
    BRL: 'brazil',
    ARS: 'argentina',
    UYU: 'uruguay',
    BOB: 'bolivia',
  };


  const handleChangeSupplier = (value: any) => {
    setSelectedSupplier(value);
    setValue('supplier', value ? value.description : null);
  };

  const getDiscounts = async () => {
    await axios.get(`${process.env.REACT_APP_API_BACKEND}/discounts?enabled=1`, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token_hhrr_latam')}`
      }
    }).then((response: any) => {
      setDiscounts(response.data);
      setValue('discount_id', null);
    }).catch((error: AxiosError) => {
      console.log('Error', error);
    });
  };

  const getGenerations = async (career_id: number) => {
    await axios.get(`${process.env.REACT_APP_API_BACKEND}/careers/${career_id}/generations`, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token_hhrr_latam')}`
      }
    }).then((response: any) => {
      setGenerations(response.data);
      setSelectedGeneration(response.data[0]);
      setValue('generation_id', response.data[0].id);
    }).catch((error: AxiosError) => {
      console.log('Error', error);
    });
  };

  const formatPrice = (value: number) => {
    return new Intl.NumberFormat('es-ES', {}).format(value);
  };

  const handleChangeFormType = (value: { id: number; name: string }) => {
    setSelectForm(value);
    setValue('form_type_id', value.id);
  };

  const handleChangeRadio = (row: CareerPrice) => {
    setSelectedPrice(row);
    setValue('price_id', row.id);
    setCheckRadioBtn(true);
    if (selectedPrice?.id !== row.id) {
      setSelectedPaymentMethod(null);
      setValue('payment_method_id', null);
      setSelectedSupplier(null);
      setValue('supplier', null);
    }
  };

  useEffect(() => {
    setDisabledForm(!(checkRadioBtn && selectForm && selectedPaymentMethod && selectedSupplier));
  }, [checkRadioBtn, selectForm, selectedPaymentMethod, selectedSupplier]);

  const onSubmit: SubmitHandler<RegisterLinkType> = async (data) => {
    setLoading(true);

    await axios
      .post(`${process.env.REACT_APP_API_BACKEND}/registers`, data, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token_hhrr_latam')}`
        }
      })
      .then(async (response: any) => {
        props.addData(response.data);
        await axios
          .get(
            `${process.env.REACT_APP_API_BACKEND}/registers/${response.data[0].id}/notification`,
            {
              headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token_hhrr_latam')}`
              }
            }
          )
          .then(() => {
            props.actionToast('success');
          })
          .catch((error: AxiosError) => console.log('Error => ', error))
          .finally(() => closeModal());
      })
      .catch((error: AxiosError) => console.log('Error onSubmit =>', error));
  };

  const summaryPriceRaw = (() => {
    if (!selectedPrice) return null;
    const isPro = selectedEnrollmentType?.id === 0;
    if (isPro && isVariant && selectedPrice.pro_variant_value != null) return Number(selectedPrice.pro_variant_value);
    if (isPro && selectedPrice.pro_value != null) return Number(selectedPrice.pro_value);
    if (isVariant && selectedPrice.variant_value != null) return Number(selectedPrice.variant_value);
    return selectedPrice.reference_value != null ? Number(selectedPrice.reference_value) : null;
  })();

  const summaryPriceValue = summaryPriceRaw != null && selectedPrice
    ? `${selectedPrice.currency?.code ?? ''} ${formatPrice(summaryPriceRaw)}`
    : null;

  const arancelDiscount = summaryPriceRaw != null
    ? Math.round(summaryPriceRaw * (1 - totalDiscountPct / 100))
    : null;

  const summaryTotal = (() => {
    if (arancelDiscount == null || !selectedPrice) return null;
    const tuition = tuitionExempted ? 0 : (selectedPrice.tuition ?? 0);
    return arancelDiscount + tuition;
  })();

  const installmentBreakdown = (() => {
    if (selectedPaymentMethod?.id !== 1 || arancelDiscount == null || quotes <= 0) return null;
    const base = Math.floor(arancelDiscount / quotes);
    const remainder = arancelDiscount - base * quotes;
    return { first: base + remainder, rest: base, quotes };
  })();

  const summaryItems = [
    { label: 'Usuario', value: nameUser ? String(nameUser) : null },
    { label: 'Curso', value: selectedCareers?.description ?? null },
    { label: 'Generación', value: selectedGeneration?.description ?? null },
    { label: 'Formulario', value: selectForm?.name ?? null },
    { label: 'Tipo de matrícula', value: selectedEnrollmentType?.description ?? null },
    {
      label: 'Tabla de precio',
      value: selectedPrice
        ? `${selectedPrice.name}${summaryPriceValue ? ` · ${summaryPriceValue}` : ''}`
        : null
    },
    {
      label: 'Modalidad',
      value: selectedPaymentMethod
        ? selectedPaymentMethod.id === 1 ? `${selectedPaymentMethod.description} · ${quotes} cuotas` : selectedPaymentMethod.description
        : null
    },
    {
      label: 'Descuento campaña',
      value: selectedDiscount ? `${selectedDiscount.description} (${selectedDiscount.percentage}%)` : null
    },
    {
      label: 'Descuento alianza',
      value: selectedAllianceDiscount ? `${selectedAllianceDiscount.description} (${selectedAllianceDiscount.percentage}%)` : null
    },
    {
      label: 'Descuento total',
      value: totalDiscountPct > 0 ? `${totalDiscountPct}%` : null
    },
    { label: 'Documento', value: selectedPaymentType?.description ?? null },
    { label: 'Medio de pago', value: selectedSupplier?.description ?? null },
    ...(isVariant ? [{ label: 'Variante', value: selectedCareers?.variant_friendly_name ?? 'Sí' }] : []),
    {
      label: 'Matrícula',
      value: selectedPrice
        ? tuitionExempted
          ? 'Sin matrícula'
          : selectedPrice.tuition != null
            ? `${selectedPrice.currency?.code ?? ''} ${formatPrice(selectedPrice.tuition)}`
            : null
        : null
    },
    ...(installmentBreakdown
      ? installmentBreakdown.first !== installmentBreakdown.rest
        ? [
            { label: '1ª cuota', value: `${selectedPrice?.currency?.code ?? ''} ${formatPrice(installmentBreakdown.first)}` },
            { label: `Cuotas 2 a ${installmentBreakdown.quotes}`, value: `${selectedPrice?.currency?.code ?? ''} ${formatPrice(installmentBreakdown.rest)}` },
          ]
        : [{ label: `Cuotas (${installmentBreakdown.quotes})`, value: `${selectedPrice?.currency?.code ?? ''} ${formatPrice(installmentBreakdown.first)}` }]
      : []),
    {
      label: 'Total a pagar',
      value: summaryTotal != null
        ? `${selectedPrice?.currency?.code ?? ''} ${formatPrice(summaryTotal)}`
        : null
    },
  ].filter(item => item.value !== null);

  return (
    <div className='window-background' id='window-background' ref={modalRef}>
      <div className='window-container width-form' id='window-container' ref={containerRef} style={{ maxWidth: '1150px', padding: '1rem' }}>
        {loading ? (
          <div className='absolute top-0 left-0 w-full h-full bg-white z-10 grid place-items-center rounded-xl'>
            <div className='flex flex-col items-center'>
              <ProgressSpinner />
              <h1>Cargando..</h1>
            </div>
          </div>
        ) : (
          <>
            <div className='flex items-center justify-between mb-3'>
              <h2 className='text-lg font-semibold text-gray-800'>Crear Enlace</h2>
              <button type='button' onClick={closeModal} className='text-gray-400 hover:text-gray-600 text-lg leading-none'>✕</button>
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className='flex gap-4'>

                {/* ── Formulario ── */}
                <div className='flex-1 space-y-2 min-w-0'>

                  {/* Usuario */}
                  <div>
                    <p className='text-xs text-gray-400 uppercase tracking-wider mb-1'>Usuario</p>
                    <div className='grid grid-cols-2 gap-2'>
                      <div>
                        <div className='flex'>
                          <input
                            type='email'
                            value={inputEmail}
                            onKeyDown={(e: any) => { if (e.code === 'Enter') e.preventDefault(); }}
                            placeholder='Correo electrónico'
                            onChange={(e) => setInputEmail(e.target.value)}
                            className='flex-1 py-1.5 px-3 text-sm rounded-l-lg border border-gray-300 border-r-0'
                          />
                          <button
                            type='button'
                            className='bg-green-500 hover:bg-green-600 px-3 rounded-r-lg text-white text-sm'
                            onClick={searchUserByEmail}
                          >
                            Buscar
                          </button>
                        </div>
                        {errorEmail && <p className='text-red-500 text-xs mt-0.5'>Usuario no encontrado</p>}
                        {errorUserData && <p className='text-red-500 text-xs mt-0.5'>Sin nombre o apellido en Hubspot</p>}
                      </div>
                      <input
                        type='text'
                        value={nameUser}
                        disabled
                        placeholder='Nombre del usuario'
                        className='py-1.5 px-3 text-sm rounded-lg border border-gray-300 bg-gray-100 text-gray-500'
                      />
                    </div>
                  </div>

                  <hr className='border-gray-100' />

                  {/* Programa */}
                  <div>
                    <p className='text-xs text-gray-400 uppercase tracking-wider mb-1'>Programa</p>
                    <div className='grid grid-cols-2 gap-2'>
                      <div>
                        <p className='text-xs text-gray-500 mb-0.5'>Curso</p>
                        <Dropdown
                          value={selectedCareers}
                          options={careers}
                          disabled={disabledInput}
                          onChange={(e) => handleChangeCareer(e.value)}
                          optionLabel='description'
                          filter
                          placeholder='Seleccionar'
                          className='w-full'
                        />
                      </div>
                      <div>
                        <p className='text-xs text-gray-500 mb-0.5'>Generación</p>
                        <Dropdown
                          value={selectedGeneration}
                          options={generations}
                          disabled={disabledInput}
                          onChange={(e) => handleChangeGeneration(e.value)}
                          optionLabel='description'
                          filter
                          placeholder='Seleccionar'
                          className='w-full'
                        />
                      </div>
                      <div>
                        <p className='text-xs text-gray-500 mb-0.5'>País / Moneda</p>
                        <Dropdown
                          value={selectedCurrency}
                          options={availableCurrencies}
                          disabled={disabledInput || !selectedCareers}
                          onChange={(e) => handleChangeCurrency(e.value)}
                          optionLabel='code'
                          itemTemplate={(c) => <span>{currencyLabels[c.code] ?? c.code}</span>}
                          valueTemplate={(c) => c ? <span>{currencyLabels[c.code] ?? c.code}</span> : <span className='text-gray-400'>Seleccionar</span>}
                          placeholder='Seleccionar'
                          className='w-full'
                        />
                      </div>
                      <div>
                        <p className='text-xs text-gray-500 mb-0.5'>Tipo de formulario</p>
                        <Dropdown
                          value={selectForm}
                          options={forms}
                          disabled={disabledInput}
                          onChange={(e) => handleChangeFormType(e.value)}
                          optionLabel='name'
                          placeholder='Seleccionar'
                          className='w-full'
                        />
                      </div>
                      <div>
                        <p className='text-xs text-gray-500 mb-0.5'>Tipo de matrícula</p>
                        <Dropdown
                          value={selectedEnrollmentType}
                          options={enrollmentTypes}
                          disabled={disabledInput}
                          onChange={(e) => handleChangeEnrollmentType(e.value)}
                          optionLabel='description'
                          placeholder='Base o Pro'
                          className='w-full'
                        />
                      </div>
                    </div>
                  </div>

                  {/* Tabla de precios */}
                  {selectedCareers && (
                    <>
                      <hr className='border-gray-100' />
                      <div>
                        <p className='text-xs text-gray-400 uppercase tracking-wider mb-1'>Tabla de precios</p>
                        <div className='overflow-auto max-h-28 rounded-lg border border-gray-200'>
                          <table className='w-full text-xs'>
                            <thead className='bg-gray-50 text-gray-500 sticky top-0'>
                              <tr>
                                <th className='px-2 py-1.5 w-7'></th>
                                <th className='px-2 py-1.5 text-left font-medium'>Nombre</th>
                                <th className='px-2 py-1.5 text-left font-medium'>Moneda</th>
                                <th className='px-2 py-1.5 text-right font-medium'>Valor Base</th>
                                <th className='px-2 py-1.5 text-right font-medium'>Valor Pro</th>
                                {selectedCareers.has_variant && <th className='px-2 py-1.5 text-right font-medium'>Valor Variante</th>}
                                {selectedCareers.has_variant && <th className='px-2 py-1.5 text-right font-medium'>Valor Pro Variante</th>}
                                <th className='px-2 py-1.5 text-right font-medium'>Matrícula</th>
                              </tr>
                            </thead>
                            <tbody className='bg-white divide-y divide-gray-100'>
                              {selectedCareers.prices.filter(p => p.career_id === selectedCareers.id && (!selectedCurrency || p.currency?.id === selectedCurrency.id)).map((price, index) => {
                                const referenceValue = price.reference_value;
                                const isSelected = selectedPrice?.id === price.id;
                                return (
                                  <tr
                                    key={index}
                                    className={`cursor-pointer ${isSelected ? 'bg-green-50' : 'hover:bg-gray-50'}`}
                                    onClick={() => handleChangeRadio(price)}
                                  >
                                    <td className='px-2 py-1.5 text-center'>
                                      <input
                                        type='radio'
                                        name='select-row'
                                        checked={isSelected}
                                        onChange={() => handleChangeRadio(price)}
                                        className='accent-green-500'
                                      />
                                    </td>
                                    <td className='px-2 py-1.5 text-gray-700'>{price.name}</td>
                                    <td className='px-2 py-1.5 text-gray-500'>{price.currency?.code ?? '-'}</td>
                                    <td className='px-2 py-1.5 text-right text-gray-700'>{referenceValue != null ? `$ ${formatPrice(referenceValue)}` : '-'}</td>
                                    <td className='px-2 py-1.5 text-right text-gray-700'>{price.pro_value != null ? `$ ${formatPrice(price.pro_value)}` : '-'}</td>
                                    {selectedCareers.has_variant && <td className='px-2 py-1.5 text-right text-gray-700'>{price.variant_value != null ? `$ ${formatPrice(price.variant_value)}` : '-'}</td>}
                                    {selectedCareers.has_variant && <td className='px-2 py-1.5 text-right text-gray-700'>{price.pro_variant_value != null ? `$ ${formatPrice(price.pro_variant_value)}` : '-'}</td>}
                                    <td className='px-2 py-1.5 text-right text-gray-700'>{price.tuition != null ? `$ ${formatPrice(price.tuition)}` : '-'}</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}

                  <hr className='border-gray-100' />

                  {/* Pago */}
                  <div>
                    <p className='text-xs text-gray-400 uppercase tracking-wider mb-1'>Condiciones de pago</p>
                    <div className='grid grid-cols-2 gap-2'>
                      <div>
                        <p className='text-xs text-gray-500 mb-0.5'>Modalidad</p>
                        <Dropdown
                          value={selectedPaymentMethod}
                          options={selectedPrice?.payment_methods ?? []}
                          disabled={disabledInput || !selectedPrice}
                          onChange={(e) => handleChangePaymentMethod(e.value)}
                          optionLabel='description'
                          placeholder='Anticipado o Cuotas'
                          className='w-full'
                        />
                      </div>
                      {selectedPaymentMethod?.id === 1 && (
                        <div>
                          <p className='text-xs text-gray-500 mb-0.5'>Número de cuotas</p>
                          <input
                            type='number'
                            min={1}
                            max={48}
                            value={quotes}
                            disabled={disabledInput}
                            onChange={(e) => {
                              const val = Number(e.target.value);
                              setQuotes(val);
                              setValue('quotes', val);
                            }}
                            className='w-full py-1.5 px-3 text-sm rounded-lg border border-gray-300'
                          />
                        </div>
                      )}
                      <div>
                        <p className='text-xs text-gray-500 mb-0.5'>Descuento campaña</p>
                        <Dropdown
                          value={selectedDiscount}
                          options={campaignDiscounts}
                          disabled={disabledInput || !selectedPaymentMethod}
                          onChange={(e) => handleChangeDiscount(e.value)}
                          optionLabel='description'
                          filter
                          showClear
                          placeholder={selectedPaymentMethod ? 'Sin descuento' : 'Selecciona una modalidad primero'}
                          className='w-full'
                          itemTemplate={(d) => <span>{d.description} <span className='text-gray-400 text-xs'>({d.percentage}%)</span></span>}
                          valueTemplate={(d) => d ? <span>{d.description} <span className='text-gray-400 text-xs'>({d.percentage}%)</span></span> : <span className='text-gray-400'>Sin descuento</span>}
                        />
                      </div>
                      <div>
                        <p className='text-xs text-gray-500 mb-0.5'>Descuento alianza</p>
                        <Dropdown
                          value={selectedAllianceDiscount}
                          options={allianceDiscounts}
                          disabled={disabledInput || !selectedPaymentMethod}
                          onChange={(e) => handleChangeAllianceDiscount(e.value)}
                          optionLabel='description'
                          filter
                          showClear
                          placeholder='Sin alianza'
                          className='w-full'
                          itemTemplate={(d) => <span>{d.description} <span className='text-gray-400 text-xs'>({d.percentage}%)</span></span>}
                          valueTemplate={(d) => d ? <span>{d.description} <span className='text-gray-400 text-xs'>({d.percentage}%)</span></span> : <span className='text-gray-400'>Sin alianza</span>}
                        />
                      </div>
                      <div>
                        <p className='text-xs text-gray-500 mb-0.5'>Tipo de documento</p>
                        <Dropdown
                          value={selectedPaymentType}
                          options={paymentTypes}
                          disabled={disabledInput}
                          onChange={(e) => handleChangePaymentType(e.value)}
                          optionLabel='description'
                          placeholder='Boleta o Factura'
                          className='w-full'
                        />
                      </div>
                      <div>
                        <p className='text-xs text-gray-500 mb-0.5'>Medio de pago</p>
                        <Dropdown
                          value={selectedSupplier}
                          options={availableSuppliers}
                          disabled={disabledInput || !selectedCurrency}
                          onChange={(e) => handleChangeSupplier(e.value)}
                          optionLabel='description'
                          placeholder={selectedCurrency ? 'Seleccionar' : 'Seleccioná moneda primero'}
                          className='w-full'
                        />
                      </div>
                    </div>
                  </div>

                  <hr className='border-gray-100' />

                  {/* Opciones adicionales */}
                  <div className='flex gap-5'>
                    <label className='flex items-center gap-2 cursor-pointer'>
                      <input
                        type='checkbox'
                        checked={isVariant}
                        disabled={!selectedCareers || !selectedCareers.has_variant}
                        onChange={(e) => {
                          setIsVariant(e.target.checked);
                          setValue('variant_application', e.target.checked);
                        }}
                        className='accent-green-500'
                      />
                      <span className='text-sm text-gray-600'>
                        Matricular en variante
                        {selectedCareers?.variant_friendly_name && (
                          <span className='text-gray-400 ml-1'>({selectedCareers.variant_friendly_name})</span>
                        )}
                      </span>
                    </label>
                    <label className='flex items-center gap-2 cursor-pointer'>
                      <input
                        type='checkbox'
                        checked={tuitionExempted}
                        onChange={(e) => {
                          setTuitionExempted(e.target.checked);
                          setValue('tuition_exempted', e.target.checked);
                        }}
                        className='accent-green-500'
                      />
                      <span className='text-sm text-gray-600'>Sin matrícula</span>
                    </label>
                  </div>
                </div>

                {/* ── Resumen ── */}
                <div className='w-48 shrink-0'>
                  <div className='sticky top-0 border border-gray-200 rounded-xl p-3'>
                    <p className='text-xs text-gray-400 uppercase tracking-wider mb-2'>Resumen</p>
                    {summaryItems.length === 0 ? (
                      <p className='text-xs text-gray-300'>Completa el formulario para ver el resumen.</p>
                    ) : (
                      <div className='space-y-2'>
                        {summaryItems.map((item, i) => (
                          <div key={i}>
                            <p className='text-xs text-gray-400 leading-none'>{item.label}</p>
                            <p className='text-xs text-gray-700 font-medium leading-snug mt-0.5'>{item.value}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

              </div>

              {/* Botones */}
              <div className='mt-3 flex justify-end gap-2'>
                <button
                  type='button'
                  className='px-4 py-1.5 rounded-lg text-sm text-gray-600 hover:bg-gray-100'
                  onClick={closeModal}
                >
                  Cancelar
                </button>
                <button
                  type='submit'
                  className={`px-4 py-1.5 rounded-lg text-sm text-white font-medium ${disabledForm ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500 hover:bg-green-600'}`}
                  disabled={disabledForm}
                >
                  Crear enlace
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};
